<template>
	<div class="tabWrapper homeUserInfo">
		<div class="main">
			<main-table
					v-if="bonusChargeFilter"
					page-title="Bonus/charge for employee"
					default-sort-by="id"
					:default-sort-desc="true"
					:uniqId="uniqId"
					:settings="getSettings"
					:flag="flag"
					:headers="headers"
					:filters-list="bonusChargeFilter"
					:list-items="bonusChargeList"
					:is-create="isCreate()"
					:is-create-permissions="true"
					:is-export="false"
					@updateEdit="onEdit"
					@updateChangeSort="onFilter"
					@updateRefreshFilters="onFilter"
					@updateSearch="onFilter"
					@updateEvent="onEvent"
					@updateSettings="onSettingsOpen"
					@updateExport="onExport"
					@updateFile="onPreview"
					@updateClickButton="onClickButton"
			></main-table>
		</div>

		<user-bonus-charge-create
				v-if="isBonusChargeCreate"
				:itemId="itemId"
				:user-id="id"
				:department-id="user.department_id"
				@updateClose="onClose"
		></user-bonus-charge-create>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('bonus-charge')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="getSettings"
		></table-settings>

		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
				:preloader="isPreloader"
		></remove-block>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>

		<preview-document v-if="previewLink" ></preview-document>

	</div>
</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
// components async
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PERMISSIONS, TAB } from "@/constants/constants";
import previewMixins from "@/mixins/previewMixins";
import UserBonusChargeCreate from "@/pages/UserProfile/Dialogd/UserBonusChargeCreate.vue";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";

export default {
	name: "UserTabBonusCharge",
	mixins: [ settingsMixins, removeMixins, previewMixins ],
	components: { DialogRemove, UserBonusChargeCreate, PreviewDocument, RemoveBlock, },
	computed: {
		...mapGetters([
			"bonusChargeList", "bonusChargeFilter", "permissions", "permissionsDefault"
		]),
	},
	props: {
		user: Object,
	},
	data: () => ({
		flag: TAB.USER_TAB_BONUS_CHARGE,
		isBonusChargeCreate: false,
		removeId: null,
		isPreloader: false,
		id: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,
		filterModList: {},
	}),
	methods: {
		...mapActions([
			"getBonusChargeUser",
			"onBonusChargeFilterUser",
			"onBonusChargeEdit",
			"onExportLink",
			"onRemoveBonusCharge"
		]),

		async onRemove() {
			this.isPreloader = true;
			await this.onRemoveBonusCharge(this.activeItem);
			this.onCloseRemove();
			// await this.onBonusChargeFilterUser({ filter_employee: [ this.id ] });
			this.onFilter();
			this.isPreloader = false;
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		isCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.CREATE ];
			return getPermissionsMod({ list, path });
		},

		async onEdit({ line }) {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.EDIT ];
			const perm = getPermissionsMod({ list, path });
			if (perm) {
				const { id } = line;
				this.itemId = id;
				this.isBonusChargeCreate = true;
			}
		},

		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'bonus-charge' });
		},
		onClose() {
			this.isBonusChargeCreate = false;
		},
		onEvent({ flag }) {
			if (flag === "create") {
				this.itemId = null;
				this.isBonusChargeCreate = true;
			}
		},
		async onFilter(args) {
			const id = this.id;
			if (args) {
				const { filterModList } = args;
				this.filterModList = { filterModList };

				if (!filterModList.filter_employee) {
					filterModList.filter_employee = [ id ];
				} else if (!filterModList.filter_employee.includes(id)) {
					filterModList.filter_employee.push(id);
				}
				await this.onBonusChargeFilterUser(filterModList);
			} else {
				this.filterModList.filter_employee = [ id ];
				await this.onBonusChargeFilterUser(this.filterModList);
			}

		},
		async onRemoveItem() {
			this.isPreloader = true;
			await this.onRemoveBonusCharge(this.removeId);
			this.isRemove = false;
			this.isPreloader = false;
		},
		onClickButton({ key, item }) {
			this.activeItem = item;
			if (key === "delete") {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (perm) {
					// this.getRemoveItem(item.id);

					const title = TITLE.REMOVE_THIS_RECORD;
					const text = TEXT.REMOVE_THIS_RECORD;
					this.onRemoveDialog({ title, text });
				}

			}

			if (key === "edit") {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.EDIT ];
				const perm = getPermissionsMod({ list, path });
				if (perm) {
					this.itemId = item.id;
					this.isBonusChargeCreate = true;
				}
			}

			if (key === "view") {
				this.onPreview(item.file);
			}
		},
	},
	async created() {
		this.id = this.$route.params.id;
		const id = this.$route.params.id;

		// await this.getBonusChargeUser();
		await this.onBonusChargeFilterUser({ filter_employee: [ id ] });

	},
};
</script>
